import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ChannelTalkProvider } from './context/ChannelTalkContext';
import Modal from 'react-modal';
import { RecoilRoot } from 'recoil';

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (error.response?.status === 401) {
        sessionStorage.removeItem('access_token');
        alert('비정상적인 접근입니다. 다시 로그인해주세요.');
        window.location.href = '/resume';
      }
    },
  }),
});
Modal.setAppElement('#root');
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <RecoilRoot>
    <QueryClientProvider client={queryClient}>
      <ChannelTalkProvider>
        <App />
      </ChannelTalkProvider>
    </QueryClientProvider>
  </RecoilRoot>,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
